"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ConvertSavedBlockForTCDC_1 = __importDefault(require("../../BlockNew/SavedBlocks/ConvertSavedBlockForTCDC"));
var CleanJson_1 = __importDefault(require("CleanJson/CleanJson"));
var BlockTypes_1 = require("@CommonFrontendBackend/BlockModels/BlockTypes");
var lodash_1 = require("lodash");
var getPresetTelemetryValue = function (preset) {
    var _a;
    var telemetryValues = (_a = {},
        _a[BlockTypes_1.BlockPreset.QuoteTableOnly] = "table",
        _a[BlockTypes_1.BlockPreset.QuotePlansOnly] = "plan",
        _a[BlockTypes_1.BlockPreset.QuoteCombinedPlansAndTable] = "plan_and_table",
        _a[BlockTypes_1.BlockPreset.AcceptClickTo] = "click_to_accept",
        _a[BlockTypes_1.BlockPreset.AcceptEsign] = "esign",
        _a[BlockTypes_1.BlockPreset.AcceptMultiEsign] = "multi_esign",
        _a);
    return telemetryValues[preset];
};
var esignEnabledPresets = [BlockTypes_1.BlockPreset.AcceptEsign, BlockTypes_1.BlockPreset.AcceptMultiEsign];
var insertBlockFunctionCreator = function (showAcknowledgeModal, telemetry, project, markAcceptEnabled, permissionsService, rolesService, user, projectTelemetry, projectCurrencies, currenciesUiDelegate, invoke, addDefaultTcdcStyle, account, hasBlockType, convertQuoteFromV1, savedBlockService, notifyUser, editorState, blockList, projectStore) {
    var convertSavedBlockForTCDC = invoke(ConvertSavedBlockForTCDC_1.default);
    return function (onInsertHandler) { return function (blockToInsert) {
        var _a;
        if (blockToInsert.type === "Accept" && project.hasAcceptEnabled) {
            showAcknowledgeModal({
                title: "Only 1 Accept Block",
                explainer: "Only 1 Accept block can be added to a project",
            });
            return;
        }
        var isBlockEditableOnlyByAdmins = permissionsService.isBlockEditableOnlyByAdmins(blockToInsert);
        var presetUsed = blockToInsert.$presetUsed;
        var existingBlocksEditableStatus = blockToInsert.$userAction;
        blockToInsert = (0, CleanJson_1.default)(blockToInsert);
        var isSavedBlock = blockToInsert._id != null || blockToInsert.id != null;
        var commonTelemetryProperties = {
            block_created_project_edit_session_duration: editorState.getEditSessionTime(),
            block_created_project_blocks_number: blockList.getLength() + 1,
            app_sessions_number: user.useHistory.sessionCount,
        };
        if (isSavedBlock) {
            blockToInsert = removeUnrelatedFieldsInSavedBlock(blockToInsert);
            if (blockToInsert.type === BlockTypes_1.BlockType.OldQuote && !hasBlockType(BlockTypes_1.BlockType.OldQuote)) {
                try {
                    blockToInsert = convertQuoteFromV1(account, blockToInsert);
                }
                catch (_b) {
                    notifyUser.error("An error occurred trying to insert that block: couldn't convert old style quote block");
                    return;
                }
            }
            if (blockToInsert.type === BlockTypes_1.BlockType.Quote && ((_a = blockToInsert.settings) === null || _a === void 0 ? void 0 : _a.foldable)) {
                blockToInsert.settings.foldable = {};
            }
            delete blockToInsert._id;
            blockToInsert.fromSavedBlock = blockToInsert.id;
            if (blockToInsert.settings == null) {
                blockToInsert.settings = {};
            }
            if (blockToInsert.settings.navigation == null) {
                blockToInsert.settings.navigation = { exclude: false };
            }
            if (isBlockEditableOnlyByAdmins && !rolesService.isAdmin(user)) {
                blockToInsert.$userAction = "view";
            }
            else {
                blockToInsert.$userAction = "edit";
            }
            if (blockToInsert.type === "QuoteV2") {
                if (blockToInsert.settings.currency == null) {
                    blockToInsert.settings.currency = projectCurrencies.getNewBlockCurrency();
                }
                else if (!projectCurrencies.allowingMultipleCurrencies()) {
                    if (project.quoteBlockCount > 0) {
                        blockToInsert.settings.currency = projectCurrencies.getNewBlockCurrency();
                    }
                }
            }
            telemetry.track("Block Created", __assign({ block_type: "saved block", saved_block_type: blockToInsert.type.toLowerCase(), block_source: "new" }, commonTelemetryProperties), { blockIntercom: true });
        }
        else {
            if (blockToInsert.type === "QuoteV2") {
                blockToInsert.settings.currency = projectCurrencies.getNewBlockCurrency();
            }
            if (existingBlocksEditableStatus === "view") {
                blockToInsert.$userAction = "view";
            }
            telemetry.track("Block Created", __assign(__assign({ block_type: blockToInsert.type.toLowerCase(), block_source: blockToInsert.clonedFrom ? "clone" : "new" }, (presetUsed ? { block_preset: getPresetTelemetryValue(presetUsed) } : {})), commonTelemetryProperties), { blockIntercom: true });
            if (esignEnabledPresets.includes(presetUsed)) {
                telemetry.track("E-Signature Enabled", { esign_enabled_source: "preset" }, { blockIntercom: true });
            }
        }
        editorState.incrementBlockAddedCountInEditSession();
        if (isSavedBlock) {
            convertSavedBlockForTCDC(blockToInsert);
        }
        else {
            addDefaultTcdcStyle(blockToInsert);
        }
        return onInsertHandler(blockToInsert).then(function () {
            if (blockToInsert.type === "Accept" || blockToInsert.type === "Quote") {
                markAcceptEnabled();
            }
            if (["QuoteV2", "Quote"].includes(blockToInsert.type)) {
                projectStore.incrementQuoteBlockCount();
                if (blockToInsert.type === "QuoteV2") {
                    currenciesUiDelegate.currenciesChanged();
                }
            }
            if (isSavedBlock && blockToInsert.fromSavedBlock) {
                savedBlockService.recordUsage(blockToInsert.fromSavedBlock);
            }
            projectTelemetry.projectEdited(project);
        });
    }; };
};
var removeUnrelatedFieldsInSavedBlock = function (savedBlock) {
    var omitList = ["lastEditedAt", "lastUsedAt", "parentFolder"];
    var clonedBlock = (0, lodash_1.cloneDeep)(savedBlock);
    return (0, lodash_1.omit)(clonedBlock, omitList);
};
exports.default = insertBlockFunctionCreator;
